module.exports = "https://static.energy5.com/_next/static/images/brand7-b198e5b9c36e0f2730f75b8174b35eca.png";